import PropTypes from 'prop-types';

// material-ui
import IconButton from '@mui/material/IconButton';
import MuiTooltip from '@mui/material/Tooltip';

// assets
import { IconX } from '@tabler/icons-react';

// Close icon button
const CloseIconButton = ({ text, icon: Icon = IconX, onClick, color, width, ...props }) => (
    <MuiTooltip title={text} aria-label={text}>
        <IconButton aria-label="close" color={color} onClick={onClick} {...props}>
            <Icon width={width} />
        </IconButton>
    </MuiTooltip>
);

CloseIconButton.propTypes = {
    text: PropTypes.string,
    icon: PropTypes.elementType,
    onClick: PropTypes.func.isRequired,
    color: PropTypes.string,
    width: PropTypes.number
};

export default CloseIconButton;
